module.exports = __webpack_public_path__ + "img/logo3.2989e6d7.svg";